import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RolePermission {
  module: string;
  view: boolean;
  create: boolean;
  edit: boolean;
  delete: boolean;
  publish: boolean;
}

interface UserState {
  auth: boolean;
  // Profile fields only — the access token lives in tokenStore (in-memory)
  // and the refresh token is an HttpOnly cookie the frontend never touches.
  // Neither belongs here: this slice is persisted to localStorage.
  user: {
    id: string;
    name: string;
    email: string;
    role: string;
    roleId?: string;
    /** Display name of the role record — populated for CUSTOM roles */
    roleName?: string | null;
    institution_id: string | null;
    teamId?: string | null;
    festId?: string | null;
    permissions?: RolePermission[];
    photo?: string | null;
  } | null;
}

const initialState: UserState = {
  auth: false,
  user: null,
};

const userSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<UserState['user']>) => {
      state.auth = true;
      state.user = action.payload;
    },
    logout: (state) => {
      state.auth = false;
      state.user = null;
    },
    update: (state, action: PayloadAction<Partial<UserState['user']>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    setPermissions: (state, action: PayloadAction<RolePermission[]>) => {
      if (state.user) {
        state.user.permissions = action.payload;
      }
    },
  },
});

export const { login, logout, update, setPermissions } = userSlice.actions;
export default userSlice.reducer;
